import type { JSX } from "react";

import { Menu as BaseMenu } from "@base-ui/react/menu";

import type { MenuRadioGroupProps } from "./Menu.types";

export function MenuRadioGroup({ ...props }: MenuRadioGroupProps): JSX.Element {
  return <BaseMenu.RadioGroup data-slot="menu-radio-group" {...props} />;
}
